import api from "./index";

/**
 * Fetch user farms
 * @returns {Promise<Array>}
 */
export async function fetchFarms() {
    const res =
        await api.get(
            "/farms"
        );

    return (
        res.data?.farms ??
        []
    );
}

export async function grabFarm(
    farm_id
) {
    const res =
        await api.get(
            `/farms/${farm_id}`
        );

    return (
        res.data ??
        {}
    );
}